<template>
    <div class="video-wrapper">
        <div class="hptop">
            <div class="hptop-left" @click="goback">
                <img src="https://img3a.gemtec.ltd/%E8%BF%94%E5%9B%9E%402x.png" alt="" />
                <p>返回</p>
            </div>
            <!-- <div class="hptop-right">
                <img src="../../assets/iPad icon/提示@2x.png" alt="" />
                <p>提示</p>
            </div> -->
        </div>
        <div id="hpbottom">
            <video
                id="myVideo"
                ref="video"
                :src="videoPath"
                @touchmove="touchMove"
                @touchstart="touchStart"
                @play="onplay"
                autoplay
                loop
                class="video"
             
                controls
            ></video>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            time: 3,
            startX: 0,
            startY: 0,
            throttleFlag: true,
            videoPath: "",
        };
    },

    created() {
        window.ensureSharedWorkerPortStart('app');
        this.videoPath = this.$route.query.videoPath; //获取url地址栏中id的值
    },

    mounted() {
        document.getElementById("myVideo").addEventListener("play", this.onplay);
        document.getElementById("myVideo").addEventListener("pause", this.onpause);

    },

    methods: {
        onplay() {
            const worker = window.ensureSharedWorker();
            worker.port.postMessage({
                source: 'app',
                target: 'holographic',
                type: 'updateVideoTime',
                time: this.$refs.video.currentTime,
            });
            worker.port.postMessage({
                source: 'app',
                target: 'holographic',
                type: 'playVideo',
            });
        },

        onpause(){
            const worker = window.sharedWorker;
            worker.port.postMessage({
                source: 'app',
                target: 'holographic',
                type: 'pauseVideo',
            });
        },

        // 节流
        throttle(func, delay, e) {
            if (this.throttleFlag) {
                this.throttleFlag = false;
                return func.call(this, e, delay);
            } else {
                return;
            }
        },

        touchMoveFn(e, delay) {
            var endX = Number(e.touches[0].clientX);
            var endY = Number(e.touches[0].clientY);
            console.log(this.startX);
            var diffX = endX - this.startX;
            console.log(this.startX);
            var diffY = endY - this.startY;
            try {
                if (diffX > 0) {
                    //向右移动
                    this.$refs.video.currentTime !== 0
                        ? (this.$refs.video.currentTime += this.time)
                        : 1;
                } else if (diffX < 0) {
                    //向左移动
                    this.$refs.video.currentTime !== 0
                        ? (this.$refs.video.currentTime -= this.time)
                        : 1;
                }
                const worker = window.sharedWorker;
                worker.port.postMessage({
                    source: 'app',
                    target: 'holographic',
                    type: 'updateVideoTime',
                    time: this.$refs.video.currentTime,
                });
                setTimeout(() => {
                    this.throttleFlag = true;
                }, delay);
            } catch (e) {
                console.log(e.message);
            }
        },

        touchMove(e) {
            this.throttle(this.touchMoveFn, 1000, e);
        },

        touchStart(e) {
            try {
                this.startX = Number(e.touches[0].clientX);
                this.startY = Number(e.touches[0].clientY);
            } catch (e) {
                console.log(e.message);
            }
        },

        goback() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.video-wrapper {
    background: url("../../assets/img/detailbg.jpg");
    background-size: 100%100%;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    .hptop {
        // display: flex;
        // justify-content: space-between;
        position: absolute;
        left: 10px;
        top: 10px;
        z-index: 999;
        .hptop-left {
            text-align: center;
            margin-top: 33px;
            margin-left: 40px;
            img {
                width: 61px;
                height: 57px;
                background: #1c0f08;
                border-radius: 50%;
            }
            p {
                margin-top: 9px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #fff1d8;
                line-height: 18px;
            }
        }
        .hptop-right {
            text-align: center;
            margin-top: 33px;
            margin-right: 40px;
            img {
                width: 61px;
                height: 57px;
                background: #1c0f08;
                border-radius: 50%;
            }
            p {
                margin-top: 9px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #fff1d8;
                line-height: 18px;
            }
        }
    }
    #hpbottom {
        width: 100vw;
        height: 100vh;
        background-color: #4d3c22;
        // border: 1px solid red;
        box-sizing: border-box;
        margin: 0 auto;
        overflow: hidden;
        #myVideo{
            width: 100%;
            height: 100%;
        }
    }
}
</style>